/**
 * Breakpoints ordered from smallest to largest
 */
const breakpoints = ['mobile', 'phablet', 'tablet', 'desktop', 'wide'];
const isBreakpoint = (s) => breakpoints.includes(s);
export { breakpoints, isBreakpoint };
